// src/pages/TransferPendingRecord/TransferPendingRecordThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../apiservice/apis";
import { message } from "antd";
import { transferApproveApi, transferCheckApi } from "../../apiservice/inventory";

export const fetchTransferPendingRecord = createAsyncThunk(
  "transferPendingRecord/fetch",
  async ({ selectedFilterType, selectedRecordType, filters }, { rejectWithValue }) => {
    try {
      let url = "/inventory/get-transfer-pending-record";

      if (selectedRecordType === "with item") {
        url = "/inventory/get-transfer-pending-record-with-details";
      }

      // Old UI: when filter type is item/group/category → use details API
      if (
        selectedFilterType === "By Item" ||
        selectedFilterType === "By Group" ||
        selectedFilterType === "By Category"
      ) {
        url = "/inventory/get-transfer-pending-details";
      }

      const payload = {
        selectedFilterType: selectedFilterType || null,
        toBranchId: filters?.branchId || null,
        itemId: filters?.itemId || null,
        groupId: filters?.groupId || null,
        categoryId: filters?.categoryId || null,
        userId: filters?.userId || null,
        fromDate: filters?.fromDate || null,
        toDate: filters?.toDate || null,
      };

      const res = await postData(url, payload);

      // EXACT mapping like old UI
      if (selectedRecordType === "without item" &&
          !["By Item", "By Group", "By Category"].includes(selectedFilterType)) 
      {
        return res.data.map((row) => ({
          id: row.t_id,
          vch_no: row.t_voucher_no,
          date: row.created_date,
          branch: row.to_branch_name,
          createdBy: row.full_name,
          transport_cost: Number(row.total_transport_cost).toFixed(2),
          total: Number(row.total_amount).toFixed(2),
          _raw: row
        }));
      }

      // with item mode
      if (selectedRecordType === "with item" &&
          !["By Item", "By Group", "By Category"].includes(selectedFilterType)) 
      {
        return res.data.map((master) => ({
          id: master.t_id,
          vch_no: master.t_voucher_no,
          date: master.created_date,
          branch: master.to_branch_name,
          createdBy: master.full_name,
          details: master.details
        }));
      }

      // Item / Group / Category detail mode
      return res.data.map((item) => ({
        ...item,
        id: item.t_id,
        qty_display:
          item.item_qty +
          " " +
          item.unit_symbol +
          (item.conversion > 1
            ? ", " + item.retail_qty + " " + item.base_unit_name
            : "")
      }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// export const approveTransfer = createAsyncThunk(
//   "transferPendingRecord/approve",
//   async ({ t_id }, { rejectWithValue }) => {
//     try {
//       // Step 1: check validity
//       const checkRes = await postData("/inventory/transfer-check", { t_id });
//       if (checkRes?.message !== "yes") {
//         message.error("Approval failed: Serial mismatch or stock unavailable");
//         return rejectWithValue("Failed Check");
//       }

//       // Step 2: approve
//       const approveRes = await postData("/inventory/transfer-approve", { t_id });

//       message.success(approveRes?.message || "Transfer Approved ✅");
//       return t_id;
//     } catch (err) {
//       message.error("Approval failed ❌");
//       return rejectWithValue(err.response?.data || err.message);
//     }
//   }
// );


export const approveTransfer = createAsyncThunk(
  "transfer/approve",
  async (t_id, { rejectWithValue, dispatch }) => {

    try {
      const check = await transferCheckApi({ t_id });

      if (String(check?.data?.message).toLowerCase() === "yes") {
        const approveRes = await transferApproveApi({ t_id });

        message.success(approveRes?.data?.message || "Approved successfully");

        dispatch(fetchTransferPendingRecord());

        return t_id;   // ✅ important
      } else {
        message.warning("Serial mismatch or stock unavailable");
        return rejectWithValue("not_allowed");
      }
    } catch (err) {
      message.error("Server error during approval");
      return rejectWithValue("error");
    }
  }
);
